import { useQuery } from '@apollo/client'
import { graphql } from '../../../../gql'
import { BrandNameBox, AddBrandButtonView } from './BrandNameBox'
import * as styled from '../../../../util/styled'
import { useBrandId } from '../../../../hooks/useGlobalRouting'
import { useEffect } from 'react'


const BrandsList = styled.ul('shrink-0 flex flex-col gap-4 h-full overflow-y-auto')
const BrandItem = styled.li('')

const ListBrandsForBrandSelector = graphql(`
  query ListBrandsForBrandSelector {
    brands {
      id
      title
      website
    }
  }
`)


export const BrandSelectorView = () => {
  const { data } = useQuery(ListBrandsForBrandSelector, {
    fetchPolicy: 'cache-first'
  })
  const brands = data?.brands ?? []
  const [selectedBrandId, setBrandId] = useBrandId(brands[0]?.id)
  const selectedBrand = brands.find(brand => brand.id === selectedBrandId)
  useEffect(() => {
    if (!selectedBrand && brands.length > 0) {
      setBrandId(brands[0].id)
    }
  }, [selectedBrandId, brands])
  return (
    <BrandsList>      
      {data?.brands.map(brand => (
        <BrandItem key={brand.id}>
          <BrandNameBox
            title={brand.title} url={brand.website}
            active={brand.id === selectedBrandId}
            href={`/emails?brandId=${brand.id}`}
          />
        </BrandItem>
      ))}
      <AddBrandButtonView href="/brands/new" />
    </BrandsList>
  )
}